import React from 'react';
import { comparisonIntro, comparisonRows } from '../data/siteContent';

const columns = [
  { key: 'lingq' as const, label: 'LingQ' },
  { key: 'beelinguapp' as const, label: 'Beelinguapp' },
  { key: 'koreader' as const, label: 'KOReader' },
];

const ComparisonSection: React.FC = () => {
  return (
    <section id="compare" className="border-y border-ink/12 bg-surface section-y">
      <div className="shell">
        <div className="max-w-2xl">
          <p className="kicker-action">{comparisonIntro.eyebrow}</p>
          <h2 className="display-lg mt-5 text-[2.25rem] sm:text-[3rem]">{comparisonIntro.title}</h2>
          <p className="prose-reading mt-6">{comparisonIntro.description}</p>
        </div>

        <div className="mt-14 overflow-x-auto border border-ink/20 bg-background">
          <table className="w-full min-w-[46rem] border-collapse text-left">
            <caption className="sr-only">
              How Lexeme compares with LingQ, Beelinguapp and KOReader
            </caption>
            <thead>
              <tr className="border-b border-ink/20">
                <th scope="col" className="kicker px-5 py-4 text-left font-normal">
                  <span className="sr-only">Capability</span>
                </th>
                <th
                  scope="col"
                  className="bg-primary px-5 py-4 font-display text-lg font-semibold text-white"
                >
                  Lexeme
                </th>
                {columns.map((column) => (
                  <th
                    key={column.key}
                    scope="col"
                    className="px-5 py-4 font-display text-lg font-semibold text-muted"
                  >
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {comparisonRows.map((row) => (
                <tr key={row.label} className="border-b border-ink/10 last:border-b-0">
                  <th scope="row" className="kicker px-5 py-4 align-top font-normal">
                    {row.label}
                  </th>
                  <td
                    className={`px-5 py-4 align-top font-heading text-[0.9375rem] text-ink ${
                      row.lexemeHighlight ? 'bg-highlight font-bold' : 'bg-primary/[0.06]'
                    }`}
                  >
                    {row.lexeme}
                  </td>
                  {columns.map((column) => (
                    <td
                      key={column.key}
                      className="px-5 py-4 align-top font-heading text-[0.9375rem] text-muted"
                    >
                      {row[column.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="prose-note mt-5 max-w-reading text-[0.875rem]">
          Competitor pricing and limits are as published by each app and change often — check them
          before relying on this. Lexeme is the odd one out here: the others are products you can
          install today, and it is a personal project that has never been released.
        </p>
      </div>
    </section>
  );
};

export default ComparisonSection;
